import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=2d47cbf7&"
import script from "./BlogItem.vue?vue&type=script&lang=js&"
export * from "./BlogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports